import { useEffect, useState } from "react";
import { Text } from "src/apps/components/typography/Texts";
import { useTranslations } from "src/apps/hooks/useTranslations";
import styled from "styled-components";
import { Countdown } from "../../../components/countdown/Countdown";
import { LoginTypes } from "../../../../contexts/auth/application/AuthController";

const DOCUMENTATION_AREA_LOGIN_RESEND_OTP_WAIT = "documentation_area.login.resend_otp.wait";
const DOCUMENTATION_AREA_LOGIN_RESEND_OTP = "documentation_area.login.resend_otp";
const DOCUMENTATION_AREA_LOGIN_RESEND_MAGIC_LINK = "documentation_area.login.resend_magic_link";
const DOCUMENTATION_AREA_LOGIN_RESEND_MAGIC_LINK_WAIT =
  "documentation_area.login.resend_magic_link.wait";

type ResendTwoFactorProps = {
  resendTwoFactor: () => void;
  waitFor?: number;
  loginType: LoginTypes;
};

export const ResendTwoFactor = ({
  resendTwoFactor,
  waitFor = 30,
  loginType,
}: ResendTwoFactorProps) => {
  const { t } = useTranslations();
  const [isCountdownActive, setIsCountdownActive] = useState(true);
  const [countdownSeconds, setCountdownSeconds] = useState(0);

  const RESEND_TWO_FACTOR =
    loginType === LoginTypes.EMAIL_CODE
      ? DOCUMENTATION_AREA_LOGIN_RESEND_OTP
      : DOCUMENTATION_AREA_LOGIN_RESEND_MAGIC_LINK;
  const RESEND_TWO_FACTOR_WAIT =
    loginType === LoginTypes.EMAIL_CODE
      ? DOCUMENTATION_AREA_LOGIN_RESEND_OTP_WAIT
      : DOCUMENTATION_AREA_LOGIN_RESEND_MAGIC_LINK_WAIT;

  const countdown = new Countdown({
    seconds: waitFor,
  });

  const onResendTwoFactor = () => {
    setIsCountdownActive(true);
    resendTwoFactor();
  };

  const resendTwoFactorLink = () => {
    return <Link onClick={onResendTwoFactor}>{t(RESEND_TWO_FACTOR)}</Link>;
  };

  const prettifySeconds = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  const showCountdownText = () => {
    return (
      <StyledText>
        {t(RESEND_TWO_FACTOR_WAIT, {
          timer: prettifySeconds(countdownSeconds),
        })}
      </StyledText>
    );
  };

  useEffect(() => {
    if (!isCountdownActive) {
      return;
    }

    countdown.start(setCountdownSeconds, () => setIsCountdownActive(false));
  }, [isCountdownActive]);

  return isCountdownActive ? showCountdownText() : resendTwoFactorLink();
};

const StyledText = styled(Text)`
  font-weight: 500;
  color: ${({ theme }) => theme.primaryColor};
`;

const Link = styled(StyledText)`
  cursor: pointer;
  text-decoration-line: underline;
`;
